
import smartscales1 from "../Images/fitbit-aria.webp"
import smartscales2 from "../Images/fitbit-aria-air.webp"

const smartScalesData = [
    {
        id: 1,
        src: smartscales1,
        title: "Fitbit Aria 2",
        price: "$129.95"
    },
    {
        id: 2,
        src: smartscales2,
        title: "Fitbit Aria Air",
        price: "$49.95"
    }

]

export default smartScalesData